export const SUPPORT_EMAIL = 'support@inflectionmedicine.com'
export const SUPPORT_PHONE = '+17742294004'

export const PRIVACY_POLICY_URL =
  'https://inflectionmedicine.com/documents/inflection-medicine-privacy-policy-jan2026.pdf'

export const TERMS_AND_CONDITIONS_URL =
  'https://inflectionmedicine.com/documents/inflection-website-terms-and-conditions.pdf'

export const GENETICS_101_VIDEO = {
  id: 'genetics-101',
  title: 'Genetics 101',
  src: 'https://share.synthesia.io/embeds/videos/08e292b0-8c3b-4259-94e6-83bc2e2c95a4',
} as const

export const HOME_FAQ_ITEMS = [
  {
    id: 'genetic-test',
    questionId: 'home.faq.geneticTest.question',
    questionDefault: 'What is the genetic test looking for?',
    answerId: 'home.faq.geneticTest.answer',
    answerDefault:
      "Every person has a unique set of instructions inside their cells called DNA. Whole genome sequencing (WGS) looks for differences or changes in the DNA code. Some genetic changes are harmless, while others may help explain your child's symptoms or medical condition. Finding a genetic explanation can help doctors better understand what is happening and may guide decisions about your child's care, treatment, and next steps.",
    video: {
      ...GENETICS_101_VIDEO,
      promptId: 'home.faq.geneticTest.videoPrompt',
      promptDefault: 'Watch this short video to learn more:',
      openLabelId: 'home.faq.geneticTest.videoOpenLabel',
      openLabelDefault: 'Open Genetics 101 video',
      closeLabelId: 'home.faq.geneticTest.videoCloseLabel',
      closeLabelDefault: 'Close Genetics 101 video',
      backLabelId: 'home.faq.geneticTest.videoBackLabel',
      backLabelDefault: 'Back to frequently asked questions',
    },
  },
  {
    id: 'genes-dna',
    questionId: 'home.faq.genesDna.question',
    questionDefault: 'What are genes and DNA?',
    answerId: 'home.faq.genesDna.answer',
    answerDefault:
      "DNA is the body's instruction manual. It contains the information that tells the body how to grow, develop, and function. Genes are segments of DNA that carry specific instructions for making proteins, which carry out the functions that keep the body working. Genes can influence traits like eye color, growth, development, and health.",
  },
  {
    id: 'result-types',
    questionId: 'home.faq.resultTypes.question',
    questionDefault: 'What types of results should I expect?',
    answerId: 'home.faq.resultTypes.answer',
    answerDefault:
      "Whole genome sequencing (WGS) looks for genetic changes that may help explain your child's current symptoms and medical condition. Most results focus on findings related to your child's current symptoms and medical condition.\n\nResults fall into a few categories. Sometimes the test identifies a genetic change that clearly explains your child's symptoms. In other cases, the test may not find an answer, or it may find a genetic change that science does not yet fully understand. The test may also identify genetic findings unrelated to your child's current symptoms that are still important for medical care. In either situation, your healthcare team will explain what the results mean and what follow-up steps, if any, make sense.",
  },
  {
    id: 'insurance',
    questionId: 'home.faq.insurance.question',
    questionDefault: 'Will the genetic test impact our health insurance?',
    answerId: 'home.faq.insurance.answer',
    answerDefault:
      'In the United States, there is a law called the Genetic Information Nondiscrimination Act (GINA) of 2008. This law protects people from discrimination based on genetic information in health insurance and employment. In general, this means that health insurance companies and most employers cannot use genetic test results to raise premiums and cannot deny you coverage based on genetic test results. However, GINA does not cover life insurance, disability insurance, or long-term care insurance. More information can be found here: https://www.eeoc.gov/laws/guidance/fact-sheet-genetic-information-nondiscrimination-act.',
  },
  {
    id: 'family-implications',
    questionId: 'home.faq.familyImplications.question',
    questionDefault: 'Does this result have implications for other family members?',
    answerId: 'home.faq.familyImplications.answer',
    answerDefault:
      'Sometimes the result is only about your child. Other times, it also tells you something about one or both parents. For example, if the genetic change is inherited, it means the parent carries the same genetic change and could pass it on in future pregnancies. If the genetic change is de novo, it started new in your child and the chance of it happening again is usually lower (though not always zero). Once the results are ready, your healthcare team can review the inheritance pattern and what it means for your family.',
  },
] as const
